<template>
  <v-textarea
    v-if="textarea"
    v-model="localValue"
    class="textCard__textarea-string"
    :prepend-icon="prependIcon"
    :rules="stringRules()"
    :label="label"
    :hint="hint"
    :rows="textareaRows()"
  />
  <v-text-field
    v-else
    v-model="localValue"
    class="textCard__text-field"
    :prepend-icon="prependIcon"
    :rules="stringRules()"
    :label="label"
    :hint="hint"
  />
</template>

<script>
export default {
  name: "StringField",
  props: {
    value: {
      type: String,
      default: ""
    },
    prependIcon: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    hint: {
      type: String,
      default: null
    },
    rules: {
      type: Array,
      default: null
    },
    textarea: {
      type: Boolean,
      default: false
    },
    rows: Number
  },
  data: function () {
    return {
      localValue: ""
    };
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.localValue = this.value ? this.value : "";
      }
    },
    localValue() {
      this.$emit("input", this.localValue);
    }
  },
  methods: {
    stringRules() {
      if (!this.rules) {
        return [
          (v) => !v || v.length <= 255 || "Достигнут максимальный размер"
        ];
      }
      return this.rules;
    },
    textareaRows() {
      if (typeof this.rows === "undefined") return 3;
      else return this.rows;
    }
  }
};
</script>
